import * as React from "react"
import Svg, { Path } from "react-native-svg"

function SvgComponent() {
  return (
    <Svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
    >
      <Path
        d="M15.666 17.05h.05V2.667c0-.947-.77-1.717-1.716-1.717H4c-.947 0-1.717.77-1.717 1.717V17.05H15.666zM13.05 4.333v-.05H8.283V5.05H13.05V4.333zm0 4v-.05H8.283V9.05H13.05V8.333zm0 4v-.05H8.283V13.05H13.05V12.333zM7 5.717h.05V3.617H4.95V5.717H7zm0 4h.05V7.617H4.95V9.717H7zm0 4h.05V11.617H4.95V13.717H7zm7.95 2.566H3.05V2.667c0-.524.426-.95.95-.95h10c.523 0 .95.426.95.95v13.616zM6.283 4.95h-.567v-.567h.567v.567zm0 4h-.567v-.567h.567v.567zm0 4h-.567v-.567h.567v.567z"
        fill="#434BFF"
        stroke="#434BFF"
        strokeWidth={0.1}
      />
    </Svg>
  )
}

export default SvgComponent
